import React, { useState } from 'react';
import "./SearchGoodsStyles.scss";

const SearchGoods = ({ onSearchResults }) => {
    const [searchText, setSearchText] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSearch = async () => {
        setLoading(true);
        if (onSearchResults) {
            await onSearchResults(null, searchText);
        }
        setLoading(false);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <div className="search-goods">
            <div className="search-goods__input-group">
                <input
                    type="text"
                    className="search-goods__input"
                    placeholder="Поиск товаров..."
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyPress={handleKeyPress}
                />
                <button
                    className="search-goods__button"
                    onClick={handleSearch}
                    disabled={loading}
                >
                    {loading ? 'Поиск...' : 'Найти'}
                </button>
            </div>
        </div>
    );
};

export default SearchGoods;